"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { datadogRum } from '@datadog/browser-rum';
import { buildLogContext } from '../lib';
import { datadogOptions } from './agentConfigs';
let datadogInitialized = false;
export const initializeDataDogRUM = customOptions => {
  if (!process.__browser__ || datadogInitialized) return;
  try {
    const options = _objectSpread(_objectSpread({}, datadogOptions), customOptions);
    datadogRum.init(options);
    datadogRum.setGlobalContext(buildLogContext());
    datadogInitialized = true;
    if (process.env.NODE_ENV !== "production") {
      console.log('[DataDog] RUM initialized', {
        service: options.service
      });
    }
  } catch (error) {
    console.error('[DataDog] Initialization failed:', error);
  }
};
export const getDataDogRUM = () => {
  if (!datadogInitialized && process.__browser__) initializeDataDogRUM();
  return datadogRum;
};
export const isDataDogInitialized = () => datadogInitialized;
export const __resetDataDogForTesting = () => {
  datadogInitialized = false;
};